import { useState, useEffect } from 'react';

/**
 * Hook to detect if the app is running in an iframe or standalone mode
 * @returns {Object} { isIframe: boolean, mode: 'iframe' | 'standalone' }
 */
export function useAppMode() {
  const [mode, setMode] = useState(() => {
    // Check query params first (for explicit mode override)
    const params = new URLSearchParams(window.location.search);
    const modeParam = params.get('mode');
    if (modeParam === 'iframe' || modeParam === 'standalone') {
      return modeParam;
    }

    // Check if running in iframe
    try {
      return window.self !== window.top ? 'iframe' : 'standalone';
    } catch (e) {
      // Cross-origin iframe will throw error, assume iframe mode
      return 'iframe';
    }
  });

  useEffect(() => {
    // Re-check on mount in case window state changes
    const checkMode = () => {
      try {
        const isIframe = window.self !== window.top;
        setMode(isIframe ? 'iframe' : 'standalone');
      } catch (e) {
        setMode('iframe');
      }
    };

    checkMode();
  }, []);

  return {
    isIframe: mode === 'iframe',
    mode: mode,
  };
}

